export default __webpack_public_path__ + "static/media/boton-ekampus.1b9da9b6.png";